export const REQUIRED_MSG = "هذا الحقل مطلوب";
export const INVALID_NUMBER_MSG = "قيمة غير صالحة";

const isEmpty = (value) => {
  if (value === null || value === undefined || value === "") return true;
  // Autocomplete values are {id, name} objects; an unset one comes back null,
  // but a half-built one can arrive without an id.
  if (typeof value === "object" && !Array.isArray(value)) {
    return value.id === undefined || value.id === null;
  }
  if (Array.isArray(value)) return value.length === 0;
  return false;
};

/**
 * Returns an Arabic error string, or null when the value passes.
 *
 * Deliberately small: the forms in this app validate with react-hook-form
 * `rules={{ required: true }}` and nothing else, and the server stays the
 * authority (its message is surfaced on the still-open editor).
 */
export const validateInline = (spec, value, row) => {
  if (spec.required && isEmpty(value)) return REQUIRED_MSG;

  if (!isEmpty(value)) {
    const type = typeof spec.type === "function" ? spec.type(row) : spec.type;
    if (type === "number" && Number.isNaN(Number(value))) {
      return INVALID_NUMBER_MSG;
    }
  }

  return spec.validate ? spec.validate(value, row) || null : null;
};
